import { compose } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { bindPromiseCreators } from '../../../utils/routines'

import { withUpdatePasswordSaga } from '../saga'
import { createUpdatePasswordPromise } from '../routines'
import '../../../utils/validations/extendYup'

// connect
export const mapDispatchToProps = bindPromiseCreators({
  updatePassword: createUpdatePasswordPromise
})

const connector = connect(null, mapDispatchToProps)

// formik
export const mapPropsToValues = () => ({
  password: '',
  confirm_password: ''
})

export const validationSchema = yup.object().shape({
  password: yup
    .string()
    .password()
    .required()
})

export async function handleSubmit(values, { props, setStatus, setSubmitting, resetForm }) {
  try {
    await props.updatePassword({
      ...values,
      confirm_password: values.password,
      id: props.userProfile.id
    })
    resetForm()
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}
const formik = withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})

// enhancer
export default compose(
  withUpdatePasswordSaga,
  connector,
  formik
)
